import { SectionsInterface } from '../field.interface';

export class ArrivalLayout {
	sections: SectionsInterface[] = [
		{
			title: 'Subject',
			items: [
				[
					{
						cssClass: 'col-sm-12 px-0',
						options: {
							displayType: 'map',
							gps: 'InspectionReport.property.identification.gpsCoordinates',
							show: {
								label: false,
								value: true
							}
						}
					}
				],
				[
					{
						cssClass: 'col-md-3',
						options: {
							path: 'InspectionReport.ownerOfPublicRecord'
						}
					},
					{
						cssClass: 'col-md-3',
						options: {
							path: 'InspectionReport.property.propertyAnalysis.legalDescription'
						}
					},
					{
						cssClass: 'col-md-3',
						options: {
							path: 'InspectionReport.county'
						}
					}
				],
				[
					{
						cssClass: 'col-md-3',
						options: {
							path: 'InspectionReport.property.propertyAnalysis.occupantType'
						}
					},
					{
						cssClass: 'col-md-3',
						options: {
							path: 'InspectionReport.property.lockBoxPresent',
							displayType: 'bool'
						}
					}
				],
				[
					{
						cssClass: 'col-md-3',
						options: {
							path: 'InspectionReport.property.propertyAnalysis.locationType'
						}
					},
					{
						cssClass: 'col-md-3',
						options: {
							path: 'InspectionReport.property.propertyAnalysis.pud'
						}
					},
					{
						cssClass: 'col-md-3',
						options: {
							path: 'InspectionReport.property.propertyAnalysis.unitFee',
							displayType: 'currency'
						}
					},
					{
						cssClass: 'col-md-3',
						options: {
							path: 'InspectionReport.property.propertyAnalysis.unitFeePeriodType'
						}
					}
				],
				[
					{
						cssClass: 'col-md-3',
						options: {
							path: 'InspectionReport.property.propertyAnalysis.neighborhoodConformity.conformsIndicator',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-9',
						options: {
							path: 'InspectionReport.property.propertyAnalysis.neighborhoodConformity.descriptionNoneConformity'
						}
					}
				]
			]
		},
		{
			title: 'Arrival',
			items: [
				[
					{
						cssClass: 'col-md-4',
						options: {
							path: 'InspectionReport.property.site.lot.lotSize',
							displayType: 'gla'
						}
					},
					{
						cssClass: 'col-md-4',
						options: {
							path: 'InspectionReport.property.site.lot.lotSizeEstimate',
							displayType: 'bool'
						}
					}
				],
				[
					{
						cssClass: 'col-md-3',
						options: {
							path: 'InspectionReport.property.site.offSiteFeature.road.roadType'
						}
					},
					{
						cssClass: 'col-md-3',
						options: {
							path: 'InspectionReport.property.site.offSiteFeature.road.roadMaintainedIndicator',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-3',
						options: {
							path: 'InspectionReport.property.site.offSiteFeature.road.yearRoundAccessIndicator',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-3',
						options: {
							path: 'InspectionReport.property.site.offSiteFeature.road.roadTypicalIndicator',
							displayType: 'bool'
						}
					}
				],
				[
					{
						cssClass: 'col-md-12',
						options: {
							path: 'InspectionReport.property.site.offSiteFeature.road.descriptionRoadNoneTypical'
						}
					}
				],
				[
					{
						cssClass: 'col-md-3',
						options: {
							path: 'InspectionReport.property.site.offSiteFeature.road.alleyType'
						}
					},
					{
						cssClass: 'col-md-3',
						options: {
							path: 'InspectionReport.property.site.offSiteFeature.road.alleyTypicalIndicator',
							displayType: 'bool'
						}
					}
				],
				[
					{
						cssClass: 'col-md-12',
						options: {
							path: 'InspectionReport.property.site.offSiteFeature.road.descriptionAlleyNoneTypical'
						}
					}
				],
				[
					{
						cssClass: 'col-md-4',
						options: {
							path: 'InspectionReport.property.site.zoning.zoningType'
						}
					},
					{
						cssClass: 'col-md-4',
						options: {
							path: 'InspectionReport.property.site.zoning.zoningDescription',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-4',
						options: {
							path: 'InspectionReport.property.site.zoning.zoningClassification',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-4',
						options: {
							path: 'InspectionReport.property.site.zoning.illegalDescription',
							displayType: 'bool'
						}
					}
				]
			]
		}
	];
}